function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6164 46.1945L19.8399 53.357C19.6818 53.9942 19.1099 54.4417 18.4534 54.4417H5.28558C2.91872 54.4417 1 52.5229 1 50.1561V5.45221C1 3.08535 2.91872 1.16663 5.28558 1.16663H36.7132C39.0801 1.16663 40.9988 3.08535 40.9988 5.45221V26.2564C40.9988 26.6397 40.8448 27.0068 40.5714 27.2754L22.0018 45.5194C21.8134 45.7045 21.68 45.9382 21.6164 46.1945Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 5.45221C0.5 2.80921 2.64258 0.666626 5.28558 0.666626H36.7132C39.3562 0.666626 41.4988 2.80921 41.4988 5.45221V26.2564C41.4988 26.7738 41.2909 27.2695 40.9218 27.6321L22.3522 45.876C22.2297 45.9964 22.143 46.1483 22.1017 46.3149L20.3252 53.4774C20.1118 54.3376 19.3396 54.9417 18.4534 54.9417H5.28558C2.64258 54.9417 0.5 52.7991 0.5 50.1561V5.45221ZM5.28558 1.66663C3.19486 1.66663 1.5 3.36149 1.5 5.45221V50.1561C1.5 52.2468 3.19486 53.9417 5.28558 53.9417H18.4534C18.8801 53.9417 19.2519 53.6508 19.3546 53.2367L21.1311 46.0741C21.217 45.7281 21.397 45.4126 21.6514 45.1627L40.221 26.9188C40.3987 26.7442 40.4988 26.5055 40.4988 26.2564V5.45221C40.4988 3.36149 38.8039 1.66663 36.7132 1.66663H5.28558Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71387 11.8857C6.71387 11.2893 7.19355 10.8058 7.78526 10.8058H25.6419C26.2336 10.8058 26.7133 11.2893 26.7133 11.8857C26.7133 12.4821 26.2336 12.9656 25.6419 12.9656H7.78526C7.19355 12.9656 6.71387 12.4821 6.71387 11.8857Z",
  fill: "#D64200"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71387 20.5248C6.71387 19.9284 7.17584 19.4449 7.74571 19.4449H31.822C32.3919 19.4449 32.8539 19.9284 32.8539 20.5248C32.8539 21.1213 32.3919 21.6047 31.822 21.6047H7.74571C7.17584 21.6047 6.71387 21.1213 6.71387 20.5248Z",
  fill: "#D64200"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71387 26.2844C6.71387 25.688 7.17584 25.2045 7.74571 25.2045H31.822C32.3919 25.2045 32.8539 25.688 32.8539 26.2844C32.8539 26.8808 32.3919 27.3643 31.822 27.3643H7.74571C7.17584 27.3643 6.71387 26.8808 6.71387 26.2844Z",
  fill: "#D64200"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.71387 32.0438C6.71387 31.4474 7.19355 30.9639 7.78526 30.9639H22.7848C23.3765 30.9639 23.8562 31.4474 23.8562 32.0438C23.8562 32.6402 23.3765 33.1237 22.7848 33.1237H7.78526C7.19355 33.1237 6.71387 32.6402 6.71387 32.0438Z",
  fill: "#D64200"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4246 48.6374L22.7834 56.607C22.6693 57.1611 23.2139 57.6215 23.7413 57.4167L31.6776 54.3362C31.79 54.2926 31.8918 54.2258 31.9765 54.14L44.2378 41.7213C44.5712 41.3835 44.5655 40.8388 44.225 40.5083L38.9165 35.3554C38.5837 35.0323 38.0537 35.0341 37.7229 35.3594L24.6624 48.2005C24.5416 48.3193 24.4588 48.4714 24.4246 48.6374Z",
  fill: "#171717"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M44.1366 29.0454L40.313 32.7141C40.1385 32.8815 40.1377 33.1603 40.3111 33.3287L46.2231 39.0674C46.3881 39.2275 46.6502 39.2282 46.8162 39.069L50.5959 35.4424C51.1195 34.9401 51.122 34.1039 50.6016 33.5987L45.9159 29.0504C45.421 28.57 44.6345 28.5678 44.1366 29.0454Z",
  fill: "#171717"
});

function SvgEditVrs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditVrs);
export default __webpack_public_path__ + "static/media/EditVRS.a19604e1.svg";
export { ForwardRef as ReactComponent };